import useAddressConvert from "@/hooks/useAddressConvert";
import { mobileHidden, formatNumber } from "@/utils";
import { Tabs, TabsProps, Tooltip } from "antd";
import { useState } from "react";
import useGetLinkProfitsByLimit from "@/web3Hook/useGetLinkProfitsByLimit";
import useGetUpgradeProfitsByLimit from "@/web3Hook/useGetUpgradeProfitsByLimit";
import { ProfitsByLimitType, UpgradeProfitsType } from "@/interface";
import { formatUnits } from "ethers";
import { useTranslation } from "react-i18next";
import Copy from "@/components/Copy";
import ScrollView from "@/components/ScrollView";
import dayjs from "dayjs";
const LinkHash = () => {
  const { t } = useTranslation()
  const [keys, setKeys] = useState("1");
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: t('hashrateRecord.linkComputingPower'),
    },
    {
      key: "2",
      label: t('hashrateRecord.upgradeComputingPower'),
    },
  ];
  return (
    <>
      <Tabs
        className="px-7 md:px-10"
        centered
        defaultActiveKey="1"
        onChange={(key: string) => {
          setKeys(key);
        }}
        items={items}
      />
      <div className="rounded-lg py-3.5 px-3.5 md:py-6 md:px-6 bg-green27 box-border mx-2.5 md:mx-auto md:max-w-[1200px] bg-3c">
        {keys === '1' && <LinkProfits keys={keys} />}
        {keys === '2' && <UpgradeProfits keys={keys} />}
      </div>
    </>
  );
};
// 链接算力
const LinkProfits = (props: { keys: string }) => {
  const { keys } = props;
  // 获取链接算力
  const {
    data,
    linkProfitsLod,
    getLinkProfitsByLimit,
    end,
  } = useGetLinkProfitsByLimit();

  return (
    <ScrollView scroll={{ isOver: end, loading: linkProfitsLod, onScroll: getLinkProfitsByLimit }} px={"14.8rem"} className="md:px-0">
      {data.map((item: ProfitsByLimitType, index: number) => (
        <Item data={item} key={index} keys={keys} />
      ))}
    </ScrollView>
  );
};
// 升级算力
const UpgradeProfits = (props: { keys: string }) => {
  const { keys } = props;
  // 获取升级算力
  const {
    data,
    upgradeProfitsLod,
    getUpgradeProfitsByLimit,
    end,
  } = useGetUpgradeProfitsByLimit();

  return (
    <ScrollView className="bg-3c md:px-0" scroll={{ isOver: end, loading: upgradeProfitsLod, onScroll: getUpgradeProfitsByLimit }} px={"14.8rem"}>
      {data.map((item: UpgradeProfitsType, index: number) => (
        <Item data={item} key={index} keys={keys} />
      ))}

    </ScrollView>
  );
};
const Item = (props: {
  keys: string;
  data: ProfitsByLimitType | UpgradeProfitsType;
}) => {
  const { t } = useTranslation()
  const { keys, data } = props;
  // 地址转换
  const { addressConvert } = useAddressConvert();
  return (
    <div className="flex items-center justify-between py-2.5 px-3.5 md:py-4 md:px-5 rounded bg-21 mt-2 first:mt-0">
      <div>
        <p className="text-13px md:text-sm mb-2.5 text-white">
          {keys === "1" ? t('hashrateRecord.linkComputingPower') : t('hashrateRecord.upgradeComputingPower')}
        </p>
        <p className="text-xs md:text-sm text-ad">
          {dayjs((Number(formatUnits(data.time, 0)) * 1000)).format('YYYY.MM.DD HH:mm')}
        </p>
      </div>
      <div className="text-right">
        <Tooltip className="cursor-pointer" title={formatUnits(data.amount)}>
          <p className="text-sm md:text-base text-white mb-2.5">
            +{formatNumber(formatUnits(data.amount))}
          </p>
        </Tooltip>
        {keys === "1" && (
          <p className="flex items-center text-xs md:text-sm text-ad">
            {mobileHidden(
              addressConvert((data as ProfitsByLimitType)?.provider)
            )}
            <Copy className="ml-1"
              text={addressConvert((data as ProfitsByLimitType)?.provider)} />
          </p>
        )}
      </div>
    </div>
  );
};

export default LinkHash;
